import { useState } from "react";
import { Gift, PackageOpen } from "lucide-react";
import { GIFTS } from "./RaceDemo";

const TARGET = 50;
const PRIZES = ["Səsli salam", "Şəxsi təbrik", "Yayımda adınız", "Mini oyun", "Super hədiyyə"];

export const GiftBoxDemo = () => {
  const [points, setPoints] = useState(0);
  const [floats, setFloats] = useState([]);
  const [prize, setPrize] = useState(null);

  const send = (g) => {
    if (prize) return;
    const id = Date.now() + Math.random();
    setFloats((f) => [...f, { id, g, x: 20 + Math.random() * 60 }]);
    setTimeout(() => setFloats((f) => f.filter((x) => x.id !== id)), 1200);
    setPoints((p) => {
      const n = Math.min(TARGET, p + g.add);
      if (n >= TARGET) setPrize(PRIZES[Math.floor(Math.random() * PRIZES.length)]);
      return n;
    });
  };

  return (
    <div data-testid="giftbox-demo">
      <div className="relative h-44 rounded-xl bg-[#111110] border border-white/10 overflow-hidden grid place-items-center">
        {floats.map(({ id, g, x }) => (
          <g.Icon key={id} className={`absolute bottom-4 h-8 w-8 adv-float ${g.cls}`} style={{ left: `${x}%` }} />
        ))}
        {prize ? (
          <div className="text-center" data-testid="giftbox-prize">
            <PackageOpen className="h-14 w-14 mx-auto text-emerald-300" />
            <div className="font-display text-lg font-bold mt-2">Qutu açıldı: {prize}!</div>
          </div>
        ) : (
          <div className="text-center">
            <Gift className="h-14 w-14 mx-auto text-amber-300" style={{ transform: `scale(${1 + points / 100})`, transition: "transform .3s ease" }} />
            <div className="text-sm text-[#a9a398] mt-2 font-mono" data-testid="giftbox-points">{points} / {TARGET} xal</div>
          </div>
        )}
      </div>
      <div className="h-2 rounded-full bg-white/5 mt-3 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-amber-400 to-rose-500" style={{ width: `${(points / TARGET) * 100}%`, transition: "width .3s ease" }} />
      </div>
      {prize ? (
        <button className="adv-btn-ghost w-full mt-3 text-sm" onClick={() => { setPoints(0); setPrize(null); }} data-testid="giftbox-reset">Yenidən</button>
      ) : (
        <div className="grid grid-cols-3 gap-2 mt-3">
          {GIFTS.map((g) => (
            <button key={g.key} onClick={() => send(g)} data-testid={`giftbox-gift-${g.key}`} className="adv-option py-3 flex flex-col items-center gap-1">
              <g.Icon className={`h-7 w-7 ${g.cls}`} />
              <span className="text-sm font-semibold">{g.name}</span>
              <span className="text-[11px] text-[#a9a398] font-mono">+{g.add} xal</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
